import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1/menu/tree`;

const menuService = {
  tree
};

function tree(){
  return submit('GET', url, {}, {});
}

export default menuService;
